<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Rule',
})
</script>
<template>
  <a-card title="退单申请">
    <a-table :dataSource="dataSource" :pagination="page"
    :loading="loading" :columns="columns" @change="pageChange" >
    <template #bodyCell="{ column, record,index }">
      <template v-if="column.key === 'status'">
        <a-tag color="green" v-if="record.status>0">已退单</a-tag>
        <a-tag color="red" v-else-if="record.status<0">拒绝退单</a-tag>
        <span v-else>待授理</span>
        <div v-if="record.request">{{ record.request }}</div>
      </template>

      <template v-if="column.key === 'operation'">
        <a-button-group>
           <a-button   size="small"   @click="openDetail(record.no)">
                <ContainerOutlined /> 订单详情
            </a-button>
            <a-button  v-if="pageRule.edit>0&&record.status==0"  size="small" type="primary" @click="enable(record.no,1)">
                <CheckOutlined /> 同意
            </a-button>
            <a-button  v-if="pageRule.edit>0&&record.status==0"  size="small" danger  type="primary" @click="enable(record.no,-1)">
                <CloseOutlined /> 拒绝
            </a-button>
          </a-button-group>
      </template>
    </template>
    </a-table>
    <detail ref="listdetail"></detail>
  </a-card>
</template>
<script setup lang="ts" name="Rule">
import api from '@/utils/http/service'
import LanseedFormOnly from '@/components/lanseed/formonly.vue'
import detail from './detail.vue'
import {onMounted,defineProps,ref,watch,reactive,createVNode,defineComponent} from 'vue'
import { CheckOutlined,CloseOutlined,ContainerOutlined} from '@ant-design/icons-vue'
import { useRoute } from 'vue-router'
import {DefaultRule} from '@/router/types'
import {modalinput} from '@/utils/util'


  onMounted(()=>{
    getList()
    if(useRoute().meta.rule){
      pageRule.value=useRoute().meta.rule
    }
  })
  const listdetail=ref()
  const types=ref([])
  const pageRule=ref<any>(DefaultRule())

  const columns=[
  {
      title: '订单号',
      dataIndex: 'no',key:'no'
    },
    {
      title: '退单原因',
      dataIndex: 'about',key:'about'
    },
    {
      title: '授理进度',
      dataIndex: 'status',key:'status'
    },
    {
      title: '申请时间',
      dataIndex: 'retime',key:'retime'
    },
    {
    title: '操作',
    key: 'operation',
    fixed: 'right',
    width: 100,
  },
  ]
  const page=ref<PageData>({
    current:1,
    pageSize:10,
    pageFlag:true,
    total:0,
    pageStatus:'more',
    currentKey: 'pageIndex',
    pageSizeKey: 'pageSize',
  })
  const search=(e):void=>{
    searchVal.value=e
    page.value.current=1
    getList()
  }
  const loading=ref<boolean>(false)
  const dataSource=ref<Array<any>>([])
  const getList=():void=>{
    loading.value=true
      api.list.cancellist({pageIndex:page.value.current,pageSize:page.value.pageSize}).then(res => {
        loading.value=false
        dataSource.value=res.data.data
        page.value.total=res.data.records
        page.value.current=res.data.pageIndex

      })
  }
  const pageChange=(e:anly)=>{
    page.value=e
    getList()
  }
  const openDetail=(no:Number):void=>{
    listdetail.value.getData(no)
  }
  const enable=(id:Number,able:Number):void=>{
    if(able<0){
      modalinput({
        title:'请输入拒绝原因',
        onOk(v){
           api.list.cancel(id,able,v).then(res=>{
               getList()
           })
        }
      })
    }else{
      api.list.cancel(id,able,'').then(res=>{
               getList()
      })
    }
  }
</script>
